// extracted by mini-css-extract-plugin
module.exports = {"link":"tags-module--link--15xBy"};